import React, { useState, useEffect, useRef } from "react";
import "./Testimonials.css";

const testimonials = [
  {
    name: "@Darkkniight",
    comment: "Thank you very much respectful mam and Sir, today the result came out and it was fabulous. All thanks to you and your hard work. Glad to have teachers like you on this platform .once again,Thank you ❤",
    avatar: "https://yt3.ggpht.com/lKW-yeqgmIRzM70sk2FZd6NdRyem_5JIwSM2sqxllo4hoRuw_hveQnXoA781slU4qdVAYiu6=s88-c-k-c0x00ffffff-no-rj",
  },
  {
    name: "@aryanpyx",
    comment: "We appreciate your efforts...you had done it very well. Thankyou LePic for being the part of our Engg. Journey...",
    avatar: "https://yt3.ggpht.com/9R8gmBXCB1q_zB91GdLySZRToEKeOcgSdEuOwTkoRjzIOA619Jl-VZjoCovdy_-8Kdcx7Yb8Jbw=s88-c-k-c0x00ffffff-no-rj",
  },
  {
    name: "@yashkapoor6131",
    comment: "Aap log etna effort daal rhe ho exams me ham jaagte hai to aap bhi jaag ke videos dete ho... Thankyou bas aese he sath rehna 3 rd year 4 th year me bhi, big fan LePic",
    avatar: "https://api.dicebear.com/6.x/adventurer/svg?seed=Boy",
  },
  {
    name: "@i_chahal3",
    comment: "Thnx for detailed and easily understandable notes ❤️",
    avatar: "https://yt3.ggpht.com/fpN5Jeix8McAZbbF1EpxMRuxCkFQ6_1CEnruljGJVG2CG_VEv8jjniwZWYdhDWGDMLxBiqU2AA=s88-c-k-c0x00ffffff-no-rj",
  },
  {
    name: "@rajjuali182",
    comment: "Aapke btaye huye saare topics COA. exam me aaye the....Thank uh so much",
    avatar: "https://yt3.ggpht.com/MtFwSNZZbjhWSQnbhOmMdGlzPAfZPgMNaHytwFTwhX3fIfyWBo4k3_ZMecyn9B840L1znZ4u4g=s88-c-k-c0x00ffffff-no-rj",
  },
];

const AUTO_ROTATE_INTERVAL = 4000;
const FADE_DURATION = 400; // ms

const Testimonials = () => {
  const [current, setCurrent] = useState(0);
  const [fade, setFade] = useState(true);
  const timerRef = useRef();
  const fadeTimerRef = useRef();

  useEffect(() => {
    timerRef.current && clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setFade(false);
      fadeTimerRef.current = setTimeout(() => {
        setCurrent((prev) => (prev + 1) % testimonials.length);
        setFade(true);
      }, FADE_DURATION);
    }, AUTO_ROTATE_INTERVAL);
    return () => {
      clearTimeout(timerRef.current);
      clearTimeout(fadeTimerRef.current);
    };
  }, [current]);

  const handleDotClick = (idx) => {
    if (idx === current) return;
    setFade(false);
    fadeTimerRef.current = setTimeout(() => {
      setCurrent(idx);
      setFade(true);
    }, FADE_DURATION);
  };

  return (
    <div className="testimonials-section" data-aos="fade-up">
      <h2>What Our Students Say</h2>
      <div className="testimonial-carousel">
        <div className={`testimonial-card active${fade ? " fade-in" : " fade-out"}`}>
          <img className="testimonial-avatar" src={testimonials[current].avatar} alt={testimonials[current].name} />
          <p className="testimonial-comment">“{testimonials[current].comment}”</p>
          <p className="testimonial-name">- {testimonials[current].name}</p>
        </div>
        <div className="testimonial-dots">
          {testimonials.map((_, idx) => (
            <span
              key={idx}
              className={`testimonial-dot${current === idx ? " active" : ""}`}
              onClick={() => handleDotClick(idx)}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default Testimonials; 
